import { GoogleLoginButton } from "@logora/debate.auth.google_login_button";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { withStyles } from "@mui/styles";
import React, { useState, useEffect } from "react";
import { useTranslate } from "react-admin";
import styles from "./Login.module.scss";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const callbackUrl = process.env.REACT_APP_API_AUTH_CALLBACK;



const StyledButton = withStyles({
	root: {
		marginTop: "1em !important",
		background: "#417ec7 !important",
		color: "white !important",
		"&:hover": {
			background: "#417ec799 !important",
		},
	},
})(Button);

export const Login = ({ isLoading, onSubmit }) => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const translate = useTranslate();
	const [showPassword, setShowPassword] = useState(false);
	const [password, setPassword] = useState("");
	const [userEmail, setUserEmail] = useState(urlParams.get("email") || "");

	useEffect(() => {
		localStorage.removeItem("currentUser");
		localStorage.removeItem("currentApplication");
		localStorage.removeItem("currentUserRole");
	}, []);

	const handleSubmit = (event, code = null) => {
		event?.preventDefault();
		if (code) {
			const userParams = {
				grant_type: "assertion",
				assertion_type: "google",
				assertion: code,
			};
			onSubmit(userParams);
		} else {
			const userParams = {
				grant_type: "password",
				username: userEmail,
				password: password,
			};
			onSubmit(userParams);
		}
	};

	return (
		<>
			<div className={styles.socialLogin}>
				<GoogleLoginButton
					text={translate("pos.login.google_login")}
					googleClientId={googleClientId}
					redirectUri={callbackUrl}
					onCode={(code) => handleSubmit(null, code)}
				/>
			</div>
			<div className={styles.separationContainer}>
				<div>{translate("pos.login.or_login")}</div>
			</div>
			<form className={styles.form} onSubmit={(event) => handleSubmit(event)}>
				<TextField
					required
					className={styles.formInput}
					id="email"
					type="email"
					label={translate("pos.login.email")}
					value={userEmail}
					onChange={(e) => setUserEmail(e.target.value)}
				/>
				<TextField
					required
					type={showPassword ? "text" : "password"}
					className={styles.formInput}
					id="password"
					label={translate("pos.login.password")}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									title={
										showPassword
											? translate("pos.login.hide_password")
											: translate("pos.login.show_password")
									}
									onClick={() => setShowPassword(!showPassword)}
								>
									{showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
				{isLoading ? (
					<div className={styles.submitButton}>
						<CircularProgress />
					</div>
				) : (
					<StyledButton type="submit" className={styles.submitButton}>
						{translate("pos.login.login")}
					</StyledButton>
				)}
			</form>
		</>
	);
};
